var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"slot":"activator","icon":"","flat":"","color":"grey darken-1","target":"_blank","download":"","href":_vm.exportLink},slot:"activator"},[_c('v-icon',[_vm._v("mdi-file-download")])],1),_c('span',[_vm._v(_vm._s(_vm.$t('Export')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }